import {TextField, IconButton, InputAdornment, Button, InputLabel, Select, MenuItem, FormControl, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCalendarWeek} from "@fortawesome/free-solid-svg-icons";
import moment from "moment";

Date.prototype.__GetFirstDayOfWeek = function() {
    return (new Date(this.setDate(this.getDate() - this.getDay() )));
}

function convertDateToBallCalendar(date) {
    let d = new Date(date);
    let year = d.getFullYear();
    let firstDayOfYear = new Date(year, 0, 1);

    const firstWeekNumber = {
        0: 52, // sunday
        1: 1, // monday
        2: 1, // tuesday
        3: 1, // wednesday
        4: 1, // thursday
        5: 53, // friday
        6: 52  // saturday
    }
    let firstWeekValue = firstWeekNumber[firstDayOfYear.getDay()];
    let sundayPriorToStartOfYear = firstDayOfYear.__GetFirstDayOfWeek();
    let currentSunday = d.__GetFirstDayOfWeek();
    let NumberOfWeeks = Math.ceil(Math.floor((currentSunday - sundayPriorToStartOfYear) / (24 * 60 * 60 * 1000)) / 7);
    console.log(`NumberOfWeeks ${new Date(date).toLocaleDateString()} ${new Date(date).getDay()} ${NumberOfWeeks}`);
    if (currentSunday.getFullYear() !== d.getFullYear() ||  NumberOfWeeks === 0){
        return firstWeekValue;
    }
    else {
        if (firstWeekValue === 1){
            return NumberOfWeeks+1;
        }
        else {
            return NumberOfWeeks;
        }
    }
}

// for (let month = 0; month < 12; month++) {
//     for (let day = 0; day < 30; day++) {
//         let val = convertDateToBallCalendar(new Date(2021, month, day+1).toISOString())
//         console.log(` ${month+1}/${day+1}/2022  ${val} `)
//     }
// }

function getYears() {
    let years = []
    for (let i = new Date().getFullYear() - 10; i < new Date().getFullYear() + 5; i++) {
        years.push({ label: i, value: i});
    }
    return years;
}

function getWeeks(year) {
    if (year === undefined || year === null) return [];
    // let firstDayOfYear = new Date(year, 0, 1);
    // let firstWeekNumber = convertDateToBallCalendar(firstDayOfYear);
    let lastDayOfYear = new Date(year, 11, 31);
    let lastWeekNumber = convertDateToBallCalendar(lastDayOfYear);
    // alert(lastWeekNumber)

    console.warn(` GET WEEKS ${year} ${1} ${lastWeekNumber} `);

    let weeks = []

    for (let i = 0; i < lastWeekNumber; i++) {
        weeks.push({ label: i+1, value: i+1});
    }
    return weeks;
}

export function Form_SingleWeekSelection(props) {
    const {item, localFormState, setLocalFormState} = props;
    const {inputSize = "normal", key, weekKey = "week", yearKey = "year"} = item;
    const [open, setOpen] = React.useState(false);

    const [year, setYear] = React.useState(new Date().getFullYear());
    const [years, setYears] = React.useState(getYears());
    const [week, setWeek] = React.useState(1);
    const [weeks, setWeeks] = React.useState();

    React.useEffect(() => {
        setWeeks(getWeeks(year));
    }, [year]);

    const updateLocalDate = () => {
        let val = localFormState[key];
        if (val !== undefined && val !== null){
            let [selectedYear, selectedWeek] = val.split("-");
            setYear(selectedYear);
            setWeek(selectedWeek);
        }
        else {
            setYear(new Date().getFullYear());
            setWeek(1);
        }
    };

    React.useEffect(() => {
        // setWeeks(getWeeks(new Date().getFullYear()));
        updateLocalDate();
    }, [localFormState[key]])

    const setFormWeek = () => {
        setLocalFormState({
            ...localFormState,
            [item.key]: `${year}-${week}`
        });
    }

    React.useEffect(() => {
        if (localFormState[item.key] === null || localFormState[item.key] === undefined) {
            localFormState[item.key] = `${new Date().getFullYear()}-${convertDateToBallCalendar(new Date())}`
        }
    }, [localFormState]);

    return (<>
        {(open) && (
            <Dialog
                open={true}
                onClose={() => setOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" style={{textAlign: "center"}}>
                    Select Week
                </DialogTitle>
                <DialogContent style={{width: '300px', padding: '0.5rem', display: 'flex', flexDirection: "column", gap: '1rem'}}>
                    <FormControl fullWidth>
                        <InputLabel id="year">Year</InputLabel>
                        <Select
                            labelId="year"
                            id="year-select"
                            value={year}
                            label="Year"
                            onChange={(e) => setYear(e.target.value)}
                        >
                            {years.map((i) => <MenuItem key={i.value} value={i.value}>{i.label}</MenuItem>)}
                        </Select>
                    </FormControl>
                    {year !== undefined && year !== null && (
                        <FormControl fullWidth>
                            <InputLabel id="week">Week</InputLabel>
                            <Select
                                labelId="week"
                                id="year-select"
                                value={week}
                                label="Week"
                                // onChange={handleChange}
                                onChange={(e) => setWeek(e.target.value)}
                            >
                                {weeks.map((i) => <MenuItem  key={i.value} value={i.value}>{i.label}</MenuItem>)}
                            </Select>
                        </FormControl>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        updateLocalDate();
                        setOpen(false);
                    }}>Cancel</Button>
                    <Button color={'secondary'} onClick={() => {
                        setFormWeek();
                        setOpen(false);
                    }} autoFocus>Set</Button>
                </DialogActions>
            </Dialog>

        )}
        <TextField
            label={item.label}
            helperText={item.helperText}
            variant="outlined"
            fullWidth={true}
            size={inputSize}
            InputLabelProps={{shrink: true}}
            disabled={true}
            InputProps={{
                endAdornment:
                    <InputAdornment position="end" style={{ paddingRight: '0.5rem'}}>
                        <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setOpen(true)}
                            edge="end"
                        >
                            <FontAwesomeIcon icon={faCalendarWeek} />
                            {/*<CalendarTodayIcon/>*/}
                        </IconButton>
                    </InputAdornment>

            }}
            // value={localFormState[key] || ""}
            value={ week !== undefined ? `${week}/${year}` : "" }
        />
    </>);
}